import { buildShareUrl } from '@/helpers/shareLink';

export const sharingClickAction = () => {
  let isSharing = false;
  const sharingIcon = window.storeeelItems.isMobile
    ? document.querySelector('.storeeel-menu-area-icons img[alt="sharing"]')
    : document.querySelector('#sharing-desktop');

  sharingIcon.addEventListener('click', async () => {
    if (isSharing) return;

    try {
      isSharing = true;

      const container = document.querySelector('.storeeelSwiper .swiper-slide-active .slide-media-wrapper');
      if (!container) return;

      // video/img を全部拾って「表示中のもの」を選ぶ
      const candidates = Array.from(container.querySelectorAll('video, img'));
      const visible = candidates.find(el => {
        const cs = window.getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetParent !== null;
      });

      const target = visible || candidates[candidates.length - 1]; // 念のためフォールバック
      if (!target) return;

      const campaignId = window.storeeelItems?.id ?? null;
      const groupId = container.getAttribute('group-id') ?? target.getAttribute('group-id') ?? window.iconId ?? null;
      const contentId = target.getAttribute('content-id') ?? null;

      // 連携配信の商品は、content-id / group-id が抽選ごとに変わる仮想IDになる。
      // そのまま共有すると共有先で一致するスロットが存在せず開けないため、
      // 「展開元 content の id ＋ 商品ID」という抽選に左右されない組み合わせに差し替える。
      // group-id は仮想グループIDで再現できないので載せない（共有先が content から解決する）。
      const feedSourceContentId = target.getAttribute('feed-source-content-id') || null;
      const feedProductId = target.getAttribute('feed-product-id') || null;
      const isFeedFolderTarget = Boolean(feedSourceContentId && feedProductId);

      const url = isFeedFolderTarget
        ? buildShareUrl({ campaignId, contentId: feedSourceContentId, feedProductId })
        : buildShareUrl({ campaignId, groupId, contentId });

      await window.navigator.share({ url });
    } catch {
      // noop
    } finally {
      isSharing = false;
    }
  });
};
